const getPhoneNumberLookUpUrl = (phoneNumber: any) =>
  `/proxy/twiliolookup?phoneNumber=${encodeURIComponent(phoneNumber)}`;

export { getPhoneNumberLookUpUrl };
